/**
 * Compteurs animés (blocs key_numbers, key_numbers_with_border) : [data-counter] s'anime
 * quand il est entièrement visible, une seule fois (classe `done`).
 * Librairie counterup2 (vendor.min.js, global UMD `counterUp`).
 * Remplace le composant Vue Counter.
 */
UNYC.register('counter', () => {
    const lib = window.counterUp;
    const counterUp = lib && (typeof lib === 'function' ? lib : lib.default);

    if (typeof counterUp !== 'function') return;

    const options = { duration: 800, delay: 16 };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const el = entry.target;

            if (entry.isIntersecting && !el.classList.contains('done')) {
                el.classList.add('done');
                counterUp(el, options);
                observer.unobserve(el);
            }
        });
    }, { threshold: 1 });

    UNYC.init('[data-counter]', 'counter', (el) => observer.observe(el));
});
